class ManageSubscriptions {
    constructor(el) {
        this.el = el;

        this.checkboxes = this.el.querySelectorAll('[data-newsletter-checkbox]');

        this.firstNameInput = this.el.querySelector('[name="firstName"]');
        this.lastNameInput = this.el.querySelector('[name="lastName"]');
        this.emailInput = this.el.querySelector('[name="email"]');
        this.title = this.el.querySelector('[name="title"]');
        this.company = this.el.querySelector('[name="company"]');

        this.submitButton = this.el.querySelector('[type="submit"]');
        this.unsubscrideFromAllButton = this.el.querySelector('[data-unsubscribe-from-all]');

        this.subscribeIds = [];
        this.unsubscribeIds = [];

        this.localJson = this.loadFromLocalStorage();
        if (this.localJson) {
            try {
                this.localData = JSON.parse(this.localJson);
            }
            catch (e) {
                localStorage.removeItem('newsletters');
            }
        }

        this.update();
        this.initEvents();
    }

    initEvents() {
        this.checkboxes.forEach(checkbox => {
            checkbox.addEventListener('click', this.selectNewsletters.bind(this));
        });

        this.firstNameInput.addEventListener('input', this.updateSubmitButton.bind(this));
        this.emailInput.addEventListener('input', this.updateSubmitButton.bind(this));

        this.submitButton.addEventListener('click', this.submit.bind(this));
        this.unsubscrideFromAllButton.addEventListener('click', this.unsubscribeFromAll.bind(this));
    }

    isNameValid() {
        return this.firstNameInput.value.length > 0;
    }

    isEmailValid() {
        return this.emailInput.value.length > 0;
    }

    getSelectedNewslettersIds() {
        return Array.from(this.checkboxes).filter(checkbox => checkbox.checked).map(checkbox => checkbox.dataset.newsletterCheckbox);
    }

    getAllNewslettersIds() {
        return Array.from(this.checkboxes).map(checkbox => checkbox.dataset.newsletterCheckbox);
    }

    selectNewsletters(e) {
        const checkbox = e.target;

        if (checkbox.checked)
        {
            this.subscribeIds.push(checkbox.dataset.newsletterCheckbox);

            if (this.unsubscribeIds.includes(checkbox.dataset.newsletterCheckbox)) {
                this.unsubscribeIds.splice(this.unsubscribeIds.indexOf(checkbox.dataset.newsletterCheckbox), 1);
            }
        }
        else
        {
            this.unsubscribeIds.push(checkbox.dataset.newsletterCheckbox);

            if (this.subscribeIds.includes(checkbox.dataset.newsletterCheckbox)) {
                this.subscribeIds.splice(this.subscribeIds.indexOf(checkbox.dataset.newsletterCheckbox), 1);
            }
        }

        this.updateSubmitButton();
    }

    unselectAllNewsletters() {
        this.checkboxes.forEach(checkbox => {
            checkbox.checked = false;
        });
    }

    updateSubmitButton() {
        // if (this.isNameValid() && this.isEmailValid()) {
        //     this.submitButton.disabled = false;
        // }
        // else {
        //     this.submitButton.disabled = true;
        // }
    }

    formJson() {
        return JSON.stringify({
            formId: this.el.dataset.manageSubscriptions,

            subscribeIds: this.subscribeIds,
            unsubscribeIds: this.unsubscribeIds,

            firstName: this.firstNameInput.value,
            lastName: this.lastNameInput.value,

            title: this.title.value,
            company: this.company.value,

            email: this.emailInput.value
        });
    }

    submit(e) {
        e.preventDefault();
        this.send();
    }

    unsubscribeFromAll() {
        this.subscribeIds = [];
        this.unsubscribeIds = this.getAllNewslettersIds();

        this.unselectAllNewsletters();
        this.send();
    }

    send() {
        let json = this.formJson();
        this.sendToMarketo(json).then(() => {
            this.subscribeIds = [];
            this.unsubscribeIds = [];

            json = JSON.parse(json);
            delete json.subscribeIds;
            delete json.unsubscribeIds;
            json.fieldIds = this.getSelectedNewslettersIds();

            this.saveToLocalStorage(JSON.stringify(json));
        });
    }

    sendToMarketo(json) {
        return new Promise((resolve, reject) => {
            // remove if to work
            resolve();
            if (false) {
                const xhr = new XMLHttpRequest();
                xhr.open('POST', 'https://endpoint');
                xhr.setRequestHeader('Content-Type', 'application/json');
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        resolve(xhr.response);
                    }
                    else {
                        reject(xhr.statusText);
                    }
                };
                xhr.onerror = () => {
                    reject(xhr.statusText);
                };
                xhr.send(json);
            }
        });
    }

    saveToLocalStorage(json) {
        localStorage.setItem('newsletters', json);
    }

    loadFromLocalStorage() {
        return localStorage.getItem('newsletters');
    }

    update() {
        if (this.localData) {
            this.updateBlocks();
            this.updateForm();
        }

        this.updateSubmitButton();
    }

    updateBlocks() {
        if (this.localData.fieldIds) {
            this.checkboxes.forEach(checkbox => {
                checkbox.checked = this.localData.fieldIds.includes(checkbox.dataset.newsletterCheckbox);
            });
        }
    }

    updateForm() {
        this.firstNameInput.value = this.localData.firstName || '';
        this.lastNameInput.value = this.localData.lastName || '';
        this.emailInput.value = this.localData.email || '';
        this.title.value = this.localData.title || '';
        this.company.value = this.localData.company || '';
    }
}

export default ManageSubscriptions;